import React, { useState, useEffect } from 'react'
import { Header, Page, SelecionarDataFutura } from 'components'
import { Button, Card, CardContent, Divider, Grid, TextField, Typography } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { BackButton } from 'components/BackButton/BackButton'
import { Espelho } from 'components/Espelho'
import { useTipoExameService } from 'hooks/useTipoExameService'
import { useFormState } from 'hooks/useFormState'
import { useVagaService } from 'hooks/useVagaService'
import useRouter from 'utils/useRouter'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import constants from 'utils/constants'
import { useAuth } from 'hooks/useAuth'

import useStyles from './styles'

const schema = {
  data: {
    presence: { allowEmpty: false, message: '^Data é obrigatório' },
  },
  tipoExame: {
    presence: { allowEmpty: false, message: '^Data é obrigatório' },
  },
}

export const CadastroDeVagas = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()
  moment.locale('pt-br', localization)
  const vagaService = useVagaService()
  const tipoExameService = useTipoExameService()
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [tiposExame, setTiposExame] = useState([])
  const [processandoCadastroDeVaga, setProcessandoCadastroDeVaga] = useState(false)
  const formCadastroVaga = useFormState(schema, {
    data: new Date(),
  })
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  const handleEspelho = () => {
    setAbrirEspelho(true)
  }

  useEffect(() => {
    const fetchTiposExame = async () => {
      const tipos = await tipoExameService.listarTiposExamesAsync()
      if (tipos) {
        setTiposExame(tipos)
      }
    }
    fetchTiposExame()
   
  }, [])

  const handleConfirmar = async () => {
    await vagaService.cadastrarVaga(formCadastroVaga.formState.values, setProcessandoCadastroDeVaga)
    router.history.push('/gerenciamentodevagas')
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results} md={8} sm={12} xs={12}>
        <CardContent>
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justifyContent="space-between"
            md={12}
            sm={12}
            xs={12}
          >
            <Grid item md={12} sm={12} xs={12}>
              <Typography>
                <b>DADOS SOBRE A VAGA QUE DESEJA CRIAR</b>
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12} style={{ marginTop: 0 }}>
              <Divider />
            </Grid>
            <Grid container item md={12} sm={12} xs={12} spacing={3} style={{ padding: '30px' }}>
              <Grid item md={7} sm={87} xs={12}>
                <Autocomplete
                  id="tipoExame"
                  name="tipoExame"
                  value={formCadastroVaga.formState.values.tipoExame || null}
                  options={tiposExame}
                  getOptionLabel={(option) => option.nome}
                  onChange={(event, newValue) => {
                    formCadastroVaga.handleChangeNewValueByNameProperty(
                      event,
                      newValue,
                      'tipoExame'
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      required
                      label="TIPO DE EXAME"
                      name="tipoExame"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      placeholder="Selecionar..."
                    />
                  )}
                />
              </Grid>

              <Grid item md={7} sm={7} xs={12}>
                <SelecionarDataFutura
                  dataBD={formCadastroVaga.formState.values.data}
                  callback={(data) => formCadastroVaga.handleChangeCampoData('data', data)}
                  label="DATA E HORA DA VAGA"
                  required
                  shrink
                  md={12}
                  sm={12}
                  xs={12}
                />
              </Grid>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Divider />
            </Grid>
            <Grid item container justifyContent="space-between" md={12} sm={12} xs={12}>
              <Grid item>
                <BackButton />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleEspelho}
                  className={classes.botoesFormulario}
                  color="secondary"
                  disabled={
                    !formCadastroVaga.formState.values.tipoExame ||
                    !formCadastroVaga.formState.values.data
                  }
                >
                  Cadastrar Vaga
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Espelho
        aberto={abrirEspelho}
        setAberto={setAbrirEspelho}
        handleConfirmar={handleConfirmar}
        processando={processandoCadastroDeVaga}
        titulo="CONFIRMAÇÃO DOS DADOS PREENCHIDOS"
      >
        <Grid item md={12} sm={12} xs={12}>
          <Typography>
            <h3>INFORMAÇÕES GERAIS</h3>
          </Typography>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Divider />
        </Grid>
        <Grid item container md={12} sm={12} xs={12} className={classes.fieldGroup}>
          <Grid item>
            <Typography>
              <b>TIPO DE EXAME</b>
            </Typography>
            <Typography>
              {formCadastroVaga.formState.values.tipoExame?.nome || 'Não informado'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item container md={12} sm={12} xs={12} className={classes.fieldGroup}>
          <Grid item>
            <Typography>
              <b>DATA DO EXAME</b>
            </Typography>
            <Typography>{moment(formCadastroVaga.formState.values.data).format('LLLL')}</Typography>
          </Grid>
        </Grid>
      </Espelho>
    </Page>
  )
}
